// extracted by mini-css-extract-plugin
module.exports = {"content":"UserItem_content__ZfpTQ","multiConversation":"UserItem_multiConversation__Wj8Jv"};